import { Button,Row,Col, Modal} from 'antd';
import { WeaTools,WeaSearchGroup,WeaRightMenu,WeaFormItem,WeaTop, WeaCheckbox, WeaSelect, WeaDatePicker} from 'ecCom'
import isEmpty from 'lodash/isEmpty'
import forEach from 'lodash/forEach'
import {WeaSwitch} from 'comsMobx';
import { inject, observer} from 'mobx-react';
import * as mobx from 'mobx';
import moment from 'moment';
import "../../style/systeminfo.less";
import InputBtn from '../../coms/inputBtn'
import TopButton from '../../coms/topButton';
import NeedAutoBtn from '../../coms/needAutoBtn'
import {i18n} from '../../public/i18n';
const getKey = WeaTools.getKey;
const toJS = mobx.toJS;
const confirm = Modal.confirm;

@inject('hrmSystemInfo')
@inject('hrmCard')
@observer
class HrmSystemInfo extends React.Component {
	constructor(props) {
		super(props);
		const funcs = ['doSave','edit','backCard','onPickerChange', 'onCheckChange', 'onSelectChange'];
		funcs.forEach(f=> this[f] = this[f].bind(this));
	}

	// componentWillReceiveProps(nextProps) {
	// 	const keyOld = this.props.location.key;
	// 	const keyNew = nextProps.location.key;
	// 	if(keyOld !== keyNew) {
	// 		const {hrmSystemInfo} = this.props;
	// 		hrmSystemInfo.init();
	// 		hrmSystemInfo.getFormField();
	// 	}
	// }

	componentDidMount(){
		const {hrmSystemInfo,hrmCard} = this.props;
		hrmSystemInfo.init();
		hrmSystemInfo.hrmId = this.props.params.hrmId || '';
		hrmSystemInfo.getFormField();
		hrmSystemInfo.getWeekInfo(new moment().format('YYYY-MM-DD'));
		const dom = $('<Object id="htactx" name="htactx" classid="clsid:FB4EE423-43A4-4AA9-BDE9-4335A6D3C74E" codebase="HTActX.cab#version=1,0,0,1" style="HEIGHT: 0px; WIDTH: 0px"></Object>');
		$(document.body).append(dom);
		hrmCard.setTopButtons(this.getTopButtons.bind(this));
    hrmCard.setTopRightMenus(this.getRightMenu.bind(this));
    hrmCard.setTopShowDropIcon(true);
	}

	getSearchs(){
		const {hrmSystemInfo} = this.props;
		let {isEditor, checkValue, inputVlaue, pickerValue, selectValue, options, formFields, form} = hrmSystemInfo;
		const formParams = hrmSystemInfo.getFormParams();
		const userUsbType = formParams.userUsbType || '';
		const usbState = formParams.usbstate || '';
		const {date} = hrmSystemInfo;
		const cancelSecondPwd = () => {
			confirm({
				title: i18n.confirm.defaultTitle(),
				content: (<div><div>{i18n.label['388923']()}</div><div>{i18n.label['388924']()}</div></div>),
				okText: i18n.button.ok(),
				cancelText: i18n.button.cancel(),
				width: 420,
				onOk: () => {
					form.updateFields({
						useSecondaryPwd: {
							value: '0'
						}
					})
				}
			});
		}

		const {isFormInit} = form;
		let group = [];
		let group1 = [];
		let colIndex = 1;
		isFormInit && formFields.forEach(c =>{
				c.items.forEach( field => {
						let domkey = field.domkey[0] || '';
						let hide = false;
						let hideLabel = false;

						if (userUsbType == '' && (domkey == 'tokenKey' || domkey == 'serial' || domkey == 'usbstate')) hide = true;
						if (userUsbType == '4' && (domkey == 'tokenKey' || domkey == 'serial')) hide = true;
						if (userUsbType == '2' && domkey == 'tokenKey') hide = true;
						if (userUsbType == '3' && domkey == 'serial') hide = true;
						if (!isEditor && (domkey == 'password'||domkey == 'password1')) hide = true;
						if(domkey === 'validatecode'){
							hide = isEditor ? false : true;
						}

						if(domkey == 'startUsing'){
								hide = true;
								if (isEditor && (userUsbType == '3' || userUsbType == '4') && usbState =='1' ){
										hide = false;
								}
						}

						if(!hide){
								let dom;
								if (isEditor && domkey == 'tokenKey') {
										hideLabel = true;
										const key = getKey(field);
										const bindObj = form.$(key);
										dom = <div>
														<Row>
														<Col span={7}>
																<span>{i18n.label.tokenNum()}: </span>
														</Col>
														<Col span={17} >
																<InputBtn btnText={i18n.label.binding()} {...bindObj.bind()} viewAttr={3} onBtnClick={(v)=>this.updateKey()}/>
														</Col>
														</Row>
													 </div>
								} else if (isEditor && domkey == 'serial') {
										hideLabel = true;
										const key = getKey(field);
										const bindObj = form.$(key);
										dom = <div>
														<Row>
														<Col span={7}>
																<span>{i18n.label.userKey()}: </span>
														</Col>
														<Col span={17} >
																<InputBtn btnText={i18n.label.binding()} {...bindObj.bind()} viewAttr={3} onBtnClick={(v)=>this.updateKey(v)}/>
														</Col>
														</Row>
													 </div>
								}else if (isEditor && domkey == 'startUsing') {
										hideLabel = true;
										dom = <div>
										<Row style={{lineHeight:'40px'}}>
										<Col span={6}>
											<span>{i18n.label.autoEnable()}：</span>
										</Col>
										<Col span={18} >
										<WeaCheckbox display='switch' value={checkValue} onChange={this.onCheckChange}/>
										</Col>
										</Row>
										{
												 checkValue && checkValue=='1' && <div> 
												 <Row style={{lineHeight:'40px'}}>
														<Col span={6}>
														<span>{i18n.label.enableDate()}：</span>
														</Col>
														<Col span={18} >
														<WeaDatePicker noInput startValue={new Date()} viewAttr={3} value={pickerValue} onChange={this.onPickerChange}/>
														</Col>
														</Row>
														<Row style={{lineHeight:'40px'}}>
														<Col span={6}>
														<span>{i18n.label.enableMode()}：</span>
														</Col>
														<Col span={18}>
														<WeaSelect options={options} viewAttr={3} value={selectValue} onChange={this.onSelectChange}/>
														</Col>
												</Row>
												</div>
									 }
									</div>
								}else if(domkey=='useSecondaryPwd'){
									dom = (
										<div className='wea-field-readonly'>{formParams.useSecondaryPwd === '1' ? i18n.label['15809']() : i18n.label['15808']()}</div>
									);
								}else {
									dom = <WeaSwitch fieldConfig={field} form={form} />
								}
								
								if(!isEditor){
										if(colIndex % 2 == 0){
												group1.push( <WeaFormItem
														underline
														label={`${field.label}`}
														labelCol={{span: `${window.HrmLabelCol}`}}
														wrapperCol={{span: `${window.HrmWrapperCol}`}}>
														{dom}
														</WeaFormItem>);
										}else{
												group.push( <WeaFormItem
														underline
														hideLabel={hideLabel}
														label={`${field.label}`}
														labelCol={{span: `${window.HrmLabelCol}`}}
														wrapperCol={{span: `${window.HrmWrapperCol}`}}>
														{dom}
														</WeaFormItem>); 
										} 
										colIndex++;
								}else{
									if(domkey=='password' || domkey=='password1' || domkey=='seclevel'){
											group1.push( <WeaFormItem
													label={`${field.label}`}
													labelCol={{span: `${field.labelcol}`}}
													wrapperCol={{span: `${field.fieldcol}`}}>
													{dom}
													</WeaFormItem>);
									}else if(domkey=='useSecondaryPwd'){
										group1.push( <WeaFormItem
											label={`${field.label}`}
											labelCol={{span: `${field.labelcol}`}}
											wrapperCol={{span: `${field.fieldcol}`}}>
												<div>
													<div style={{float: 'left', lineHeight: '30px', marginRight: '30px'}}>{formParams.useSecondaryPwd === '1' ? i18n.label['15809']() : i18n.label['15808']()}</div>
													{
														formParams.useSecondaryPwd === '1' &&
														<Button style={{float: 'left'}} type='primary' onClick={() => cancelSecondPwd()}>{i18n.label['26471']()}</Button>
													}
												</div>
											</WeaFormItem>);
									} else if(domkey === 'validatecode'){
										group1.push(
											<WeaFormItem
												label={`${field.label}`}
												labelCol={{span: `${field.labelcol}`}}
												wrapperCol={{span: `${field.fieldcol}`}}>
												{dom}
												<img 
								                  src={`/weaver/weaver.file.MakeValidateCode?isView=1&validatetype=0&validatenum=4&seriesnum_=${date}`}
								                  style={{cursor:'pointer', position:'absolute', top: -5, left: '105%'}} 
								                  onClick={() => hrmSystemInfo.date = new Date() }
								                />	
											</WeaFormItem>
										)
									}else{
											group.push( <WeaFormItem
													hideLabel={hideLabel}
													label={`${field.label}`}
													labelCol={{span: `${field.labelcol}`}}
													wrapperCol={{span: `${field.fieldcol}`}}>
													{dom}
													</WeaFormItem>); 
									} 

									
								}
						}
				});
		});

		return <Row>
				<Col span={12}>{group}</Col>
				<Col span={12}>{group1}</Col>
		</Row>
	}

		render() {
				const {hrmSystemInfo} = this.props;
				const {viewDate, isEditor, weekInfo, title} = hrmSystemInfo;
				const formParams = hrmSystemInfo.getFormParams();
				const {query} = this.props.location;
				if(!query.fromcard && window.location.href.indexOf("/spa/hrm/index_mobx.html")>-1){
			document.title = i18n.label.sysInfo();
		}

				return (
						<WeaRightMenu datas={this.getRightMenu()}>
						 <div className='wea-myhrm-systeminfo wea-myhrm' style={{background: '#ffffff',minHeight:window.innerHeight-146}}>
							{
								!query.fromcard &&
								<WeaTop
								title={title()}
								icon={<i className='icon-coms-hrm' />}
								iconBgcolor='#217346'
								buttons={this.getTopButtons()}
								buttonSpace={10}
								showDropIcon={true}
								dropMenuDatas={this.getRightMenu()}
								/>
							}
								<div className='hrm-my-card-basicInfo hrm-my-cardInfo wea-myhrm-systeminfo'>
								<WeaSearchGroup needTigger={true} title={i18n.label.sysInfo()} showGroup={true}>
										{this.getSearchs()}
								</WeaSearchGroup>
								</div>
						</div>
					</WeaRightMenu>
				)
		}

		getTopButtons() {
				const {hrmSystemInfo} = this.props;
				const {isEditor, buttons} = hrmSystemInfo;

				const save = <Button type="primary" onClick={this.doSave} >{i18n.button.save()}</Button>;
				const back = <Button type="primary" onClick={this.backCard} >{i18n.button.back()}</Button>;
				const edit = <Button type="primary" onClick={this.edit} >{i18n.button.modify()}</Button>;
				const btns = [];
				if (isEditor) {
						if(buttons && buttons.hasEdit){
						btns.push(save);
						btns.push(back);
					}
				} else {
					if(buttons && buttons.hasEdit){
						btns.push(edit);
					}
				}
				return btns;
			}

		doSave(){
				const {hrmSystemInfo} = this.props;
				hrmSystemInfo.doSave();
		}
		
		edit(){
				const {hrmSystemInfo} = this.props;
				hrmSystemInfo.edit();
		}

		backCard(){
				const {hrmSystemInfo} = this.props;
				hrmSystemInfo.backCard();
		}
	 
		updateKey(){
				const {hrmSystemInfo} = this.props;
				hrmSystemInfo.updateKey();
		}

		onPickerChange(v){
				const {hrmSystemInfo} = this.props;
				hrmSystemInfo.onPickerChange(v);
		}

		onCheckChange(v){
				const {hrmSystemInfo} = this.props;
				hrmSystemInfo.onCheckChange(v);
		}

		onSelectChange(v){
				const {hrmSystemInfo} = this.props;
				hrmSystemInfo.onSelectChange(v);
		}

		getRightMenu(){
				const {hrmSystemInfo} = this.props;
				const {isEditor, buttons, hrmId} = hrmSystemInfo;

				let arr = [];

				if(buttons && toJS(buttons).hasEdit){
					if (isEditor){
            arr = [{
                icon: <i className='icon-coms-common'/>,
                content: i18n.button.save(),
                key: 'save',
                onClick: key =>{
                  this.doSave();
                }
              }, {
                icon: <i className='icon-coms-go-back'/>,
                content: i18n.button.back(),
                key: 'back',
                onClick: key =>{
                  this.backCard();
                }
              }]
          } else {
            arr = [{
                icon: <i className='icon-coms-edit'/>,
                content:i18n.button.modify(),
                key: 'edit',
                onClick: key =>{
                    this.edit();
                  }
								}]
						arr.push(
							{
								icon: <i className='icon-coms-Print-log'/>,
								content:i18n.button.log(),
								key: 'showLog',
								onClick: key =>{
									window.setLogViewProps({logSmallType:i18n.smallType.HRM_RSOURCE_CARD_SYSTEM,targetId:hrmId});
								}
							}
						)
          }
				}
				return arr;
			}
}

export default HrmSystemInfo;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/card/SystemInfo.js